import { FC } from "react";
import { Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";

import { EnabledLanguages } from "@framework/constants";
import type { IUser } from "@framework/types";
import { FormWrapper } from "@dzambalaorg/mui-form";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { useUser } from "@dzambalaorg/provider-user";
import { useApiCall } from "@dzambalaorg/react-hooks";

import type { ITabPanelProps } from "../tabs";
import { validationSchema } from "./validation";

export const ProfileGeneral: FC<ITabPanelProps> = props => {
  const { open } = props;

  const user = useUser<IUser>();
  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();
  const { fn } = useApiCall((_api, values: Partial<IUser>) => {
    return user.setProfile(values);
  });

  if (!open) {
    return null;
  }

  const onClick = (): void => {
    enqueueSnackbar(formatMessage({ id: "form.hints.emailWarning" }), { variant: "info" });
  };

  const handleSubmit = async (values: Partial<IUser>, form: any): Promise<void> => {
    await fn(form, values);
  };

  const { email, displayName, language, imageUrl } = user.profile;

  const fixedValues = {
    email,
    displayName,
    language,
    imageUrl,
  };

  return (
    <Grid>
      <FormWrapper initialValues={fixedValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        <TextInput name="email" autoComplete="username" onClick={onClick} />
        <TextInput name="displayName" />
        <SelectInput name="language" options={EnabledLanguages} />
        <AvatarInput name="imageUrl" />
      </FormWrapper>
    </Grid>
  );
};
